






























import { Component, Watch } from 'vue-property-decorator'
import { UsersModule } from '@/store/Settings/UsersModule';
import Alert from '@/components/Shared/Alert.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import PageNames from '@/router/PageNames';
import User from '@/models/Settings/Users/UserSummary';
import UserCreate from '@/components/Settings/Users/UserCreate.vue';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'Users', components: { Alert, UserCreate }, metaInfo: { title: 'Users' } })
export default class extends SaascadaVue {

    PermissionUtils = PermissionUtils;
    headers = [
        { text: this.$t('pageText.users.fields.firstName'), sortable: false, width: '20%' },
        { text: this.$t('pageText.users.fields.lastName'), sortable: false, width: '20%' },
        { text: this.$t('pageText.users.fields.email'), sortable: false, width: '25%' },
        { text: this.$t('pageText.users.fields.phone'), sortable: false, width: '25%' },
        { text: this.$t('pageText.users.fields.enabled'), sortable: false, width: '10%' }
    ];
    usersPage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.usersPage = +page;
        }
    }

    async beforeMount() {
        await UsersModule.getUsers();
    }

    get users() {
        return UsersModule.users;
    }

    get totalUsersPages() {
        return UsersModule.totalUsersPages;
    }

    get loading() {
        return UsersModule.loading;
    }

    get pageSize() {
        return UsersModule.pageSize;
    }

    @Watch('usersPage')
    async onUsersPageChanged() {
        // Update current page route with page number
        this.$router.push({ name: this.$route.name, query: { page: `${this.usersPage}` } });
    }

    async navigateToUser(user: User) {
        this.$router.push({ name: PageNames.User, params: { id: user.id }, query: { tab: "0" } });
    }

}
